import ImageList from '@material-ui/core/ImageList';
import ImageListItem from '@material-ui/core/ImageListItem';
import { makeStyles } from '@material-ui/core/styles';
import { useMediaQuery } from 'react-responsive'
import Skeleton from '@material-ui/lab/Skeleton';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
  },
  item: {
    scrollSnapAlign: 'start',
  },
  imageList: {
    "&::-webkit-scrollbar": {
      display: "none"
    }, /* Chrome */
    scrollSnapType: 'x mandatory',
    flexWrap: 'nowrap',
    margin: '0px !important',
    // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
    transform: 'translateZ(0)',
  },
  title: {
    color: theme.palette.primary.light,
  },
  titleBar: {
    background:
      'linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
  },
}));

function LocalSearchSkeleton() {

  const classes = useStyles();

  const isMobcreen = useMediaQuery({ query: '(min-width: 0px) and (max-width: 768px)' })

  return (
    <div className="col-md-12" style={{ padding: '5px' }}>
      <ImageList
        style={{ width: '100%', marginTop: '10px', marginBottom: '10px', margin: 0 }}
        className={classes.imageList}
        cols={isMobcreen ? 1.2 : 3}>
        {Array(4).fill().map((_, index) => (
          <ImageListItem key={index} className="cardItem" style={{ maxWidth: 'none', flex: 'none', height: 'auto', position: 'relative', padding: '5px' }}>
            <div
              style={{ flexDirection: 'row', alignItems: 'center' }}
              className="cardItem-item local-store-card-item"
            >
              <div className="img-card imgCard lcl-store-carousel-card" style={{ width: '45%', maxWidth: '45%', minWidth: '45%', height: '125px' }}>
                <Skeleton style={{ height: '125px' }} className="img-item skeleton lcl-store-carousel-img" variant="rect" />
              </div>
              <div className="card-content" style={{ width: '55%', maxWidth: '55%', minWidth: '55%', height: '125px' }}>
                <div className='title-card' style={{ minHeight: 'auto', maxHeight: 'auto' }}>
                  <Skeleton className='skeleton' variant="rect" style={{ height: '10px', width: '100%', marginTop: '5px' }} />
                  <Skeleton className='skeleton' variant="rect" style={{ height: '10px', width: '75%', marginTop: '5px' }} />
                </div>
                <div className="content-item" style={{ padding: '5px 0px' }}>
                  <Skeleton className='skeleton' variant="rect" style={{ height: '10px', width: '80%', marginTop: '5px' }} />
                </div>
                <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                  <Skeleton className='skeleton' variant="rect" style={{ height: '10px', width: '40%', marginTop: '5px' }} />
                </div>
              </div>
            </div>
          </ImageListItem>
        ))}
      </ImageList>
    </div>
  )

};

export default LocalSearchSkeleton;